import React,  {useEffect,useState} from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import MeetingEdit from '../../components/clubs/meeting_schedule_edit';
import Autorize from '../../components/ui/autorize';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';
import Cookies from 'js-cookie'

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering


//myDate -> 0=curent ; 1=nextyear
function Meetings_Schedules({clubid,secteur,ruleWrite }) {
  
    const [ModalMeetingOpen, setModalMeetingOpen] = useState(false);
    const [editmode, setEditmode] = useState("");
    const [Meetinglist, setMeetinglist] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [current_meetId, setCurrentCurrent_meetId] = useState("");
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

  
    useEffect(() => {

        if(autorize){
            refreshLoadData();
        }   

    },[clubid,secteur]);


    function refreshLoadData()
    {       
        if(clubid !== "")
        {
                MyAxios.get(process.env.REACT_APP_API + '/meetings/get/secteur/'+ secteur +'/club/'+ clubid )
                .then((res) => {     
                    setAutorize("true");               
                    setMeetinglist(res.data);   
                    //console.log(officerlist);                    
                })
                .catch((error) => {
                    setAutorize("false");  
                });
        }          
    }

    function closeModal() {
      
        setModalOpen(false);
    }

    function openModal() {
      setModalOpen(true);
    }

       
    const voirDetail = (value) => { 
    
       setCurrentCurrent_meetId(value);         
       openModal();
    };

    
    function closeModalMeeting()
    {
        refreshLoadData();
        setModalMeetingOpen(false);
    }
    
    const onNewMeeting = (row, event) => {   
       
        setModalMeetingOpen(true);
    };

    
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
     };

     function getButtonAddSave()
     {
        if(ruleWrite === true)
            return( <Button  name="NewMeeting" variant="containedFifth" onClick={(e) => onNewMeeting(e.target.name)}>Ajouter une réunion</Button>   );
     }

     function getButtonEdit(value)
     {
        if(ruleWrite === true)
            return(  <Button size="small"  variant="containedThird" name={value.id} onClick={(e) => voirDetail(e.target.name)}>Modifier réunion</Button>   );
     }
   
        return (
            <div>
                 <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
            
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={3}> 
                        <Typography variant="h6" gutterBottom>Journée de réunion</Typography>
                    </Grid>
                    <Grid item xs={3}> 
                           {getButtonAddSave()}         
                    </Grid> 
                </Grid>

                <Grid container direction="row" spacing={1}>
              

                    <Box  sx={{display: 'flex', flexDirection: 'row' }} >
                    
                    {Object.entries(Meetinglist).map(([key, value]) => (

                        <Card sx={{ maxWidth: 345 , margin:'10px' }} key={"Meet" + value.id}>                        
                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div">
                            {value.weekday }  {value.meet_time  }  {value.freq  } 
                            </Typography>
                            <Typography variant="body2" color="text.secondary">                                
                                {value.Address1  }  <br /> 
                                {value.Address2  }  <br />                                 
                            </Typography>
                        </CardContent>
                        <CardActions>
                                                      
                            {getButtonEdit(value)}   

                        </CardActions>
                        </Card>
                    

                    
                    ))}

                    </Box>
               
                </Grid>


                    <Dialog sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                            maxWidth="xs"
                            open={modalOpen}
                    >
                            <DialogTitle>Jour et heure de réunion</DialogTitle>
                            <DialogContent dividers>
                            
                        <MeetingEdit key="editMeeting" meetId={current_meetId} clubid={clubid}  secteur={secteur} callback={closeModalMeeting}  />

                            </DialogContent>

                            <DialogActions>
                            <Button variant="containedSecondary" onClick={closeModal}>Fermer               
                            </Button>

                            </DialogActions>
                    </Dialog>
                



                            <Dialog
                                    sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                                    maxWidth="xs"
                                
                                    open={ModalMeetingOpen}
                                
                                    >
                                    <DialogTitle>Fiche de réunion</DialogTitle>
                                    <DialogContent dividers>
                                        <MeetingEdit   key="addMeeting" meetId="new" clubid={clubid}  secteur={secteur}  />
                                    </DialogContent>

                                    <DialogActions>
                                    <Button onClick={closeModalMeeting}>Fermer               
                                    </Button>

                                    </DialogActions>
                                </Dialog>
             
           
          </div>

        );
       
    
}

export default Meetings_Schedules;